var map = {
	"./diary.json": "cc78",
	"./discuz.json": "e087",
	"./help.json": "5f1f",
	"./juqing.json": "eacd",
	"./newbie.json": "bbd8",
	"./palu.json": "52a9",
	"./test.json": "3963",
	"./tongren.json": "0fba",
	"./warning.json": "6a9e",
	"./xinde.json": "27a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef4a";